import { FormControl, FormLabel, InputAdornment, TextField, Typography } from '@mui/material';
import { ControllerRenderProps, FieldError } from 'react-hook-form';

interface NumberFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  value: string;
  onChange: ControllerRenderProps['onChange'];
  error?: FieldError;
  readOnly?: boolean;
  min?: number;
  max?: number;
  textSuffix?: string;
  helperText?: string;
}

export const NumberField = ({
  label,
  disabled,
  value,
  onChange,
  error,
  name,
  readOnly,
  min = -Infinity,
  max = Infinity,
  textSuffix,
  helperText,
}: NumberFieldProps) => {
  const inputEndAdornment = textSuffix && (
    <InputAdornment position="end">
      <Typography variant="caption">{textSuffix}</Typography>
    </InputAdornment>
  );

  return (
    <>
      <FormControl fullWidth size="small">
        <FormLabel id={`${name}-label`}>{label}</FormLabel>
        <TextField
          size="small"
          type="number"
          aria-labelledby={`${name}-label`}
          value={value}
          error={!!error}
          slotProps={{ htmlInput: { min, max, readOnly }, input: { endAdornment: inputEndAdornment } }}
          disabled={disabled}
          name={name}
          onChange={(event) => onChange(event.target.value)}
          helperText={helperText}
        />
      </FormControl>
      {error ? (
        <Typography variant="caption" color="error">
          {error!.message as string}
        </Typography>
      ) : (
        <br />
      )}
    </>
  );
};

export default NumberField;
